import $ from 'jquery'
import Swiper from 'swiper'

export default () => {
  $(() => {
    if (!$('body').hasClass('home')) return

    new Swiper('.section-banners .banners.swiper-container', {
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev'
      // }
    })

    // new Swiper('.section-categories .swiper-container', {
    //   slidesPerView: 2,
    //   autoplay: true,
    //   breakpoints: {
    //     768: {
    //       slidesPerView: 'auto'
    //     }
    //   }
    // })
  })
}
